"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchValidators = exports.updateUserProfile = exports.updateUser = exports.createUser = exports.getUserProfile = exports.getPublicUserProfile = exports.searchUsers = exports.getUsersList = exports.onboardingFinished = exports.getUser = exports.logout = exports.searchUserTraqs = exports.searchUserChallenges = exports.searchUserCourses = exports.searchUserCompleteChallenges = exports.searchProviderCourses = exports.searchProviderChallenges = exports.searchProviderTraqs = exports.searchCoachCourses = exports.searchCoachChallenges = exports.searchCoachTraqs = exports.searchUserClients = exports.searchProviderCoaches = exports.deleteProviderLogo = exports.updateProviderLogo = exports.getProviderLogo = exports.searchProviderUsersByRole = exports.disable2FA = exports.enable2FA = exports.unblockUser = exports.blockUser = exports.masterLoginGetUserAvailableRoles = exports.profileEndpoint = exports.userEndpoint = exports.endpoint = void 0;
var file_1 = require("Adapters/ApiAdapter/file");
var api_1 = require("Modules/users/api");
var axios_1 = __importDefault(require("axios"));
var qs_1 = __importDefault(require("qs"));
exports.endpoint = "/api/users";
exports.userEndpoint = "/api/user";
exports.profileEndpoint = "/api/p/user/profile";
var masterLoginGetUserAvailableRoles = function (id) {
    return axios_1.default
        .get(api_1.endpoints.masterLoginGetUserAvailableRoles(id))
        .then(function (res) { return res.data.data; });
};
exports.masterLoginGetUserAvailableRoles = masterLoginGetUserAvailableRoles;
var blockUser = function (id) {
    return axios_1.default.patch(api_1.endpoints.blockUser(id)).then(function (res) { return res.data; });
};
exports.blockUser = blockUser;
var unblockUser = function (id) {
    return axios_1.default.patch(api_1.endpoints.unblockUser(id)).then(function (res) { return res.data; });
};
exports.unblockUser = unblockUser;
var enable2FA = function () {
    return axios_1.default.post("".concat(exports.endpoint, "/request-enable-two-factor-auth"));
};
exports.enable2FA = enable2FA;
var disable2FA = function () {
    return axios_1.default.post("".concat(exports.endpoint, "/request-disable-two-factor-auth"));
};
exports.disable2FA = disable2FA;
var searchProviderUsersByRole = function (provider, _a) {
    var role = _a.role, search = _a.search, page = _a.page, perPage = _a.perPage;
    return axios_1.default
        .get("/api/users/".concat(provider, "/users"), {
        params: { role: [role], search: search, page: page, perPage: perPage },
    })
        .then(function (res) { return res.data; });
};
exports.searchProviderUsersByRole = searchProviderUsersByRole;
var getProviderLogo = function () {
    return axios_1.default.get("/api/user/provider-logo");
};
exports.getProviderLogo = getProviderLogo;
var updateProviderLogo = function (logo) { return __awaiter(void 0, void 0, void 0, function () {
    var form, file;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                form = new FormData();
                if (!logo)
                    return [2 /*return*/];
                return [4 /*yield*/, (0, file_1.uploadMedia)(logo)];
            case 1:
                file = _a.sent();
                form.append("logo", file.id);
                return [2 /*return*/, axios_1.default.post("/api/user/provider-logo", form)];
        }
    });
}); };
exports.updateProviderLogo = updateProviderLogo;
var deleteProviderLogo = function () {
    return axios_1.default.delete("/api/user/provider-logo");
};
exports.deleteProviderLogo = deleteProviderLogo;
var searchProviderCoaches = function (userId, query, page, perPage, additionalParams) {
    if (query === void 0) { query = ""; }
    if (page === void 0) { page = 1; }
    if (perPage === void 0) { perPage = 20; }
    if (additionalParams === void 0) { additionalParams = ""; }
    return axios_1.default.get("".concat(exports.userEndpoint, "/").concat(userId, "/coaches?search=").concat(query, "&page=").concat(page, "&perPage=").concat(perPage).concat(additionalParams));
};
exports.searchProviderCoaches = searchProviderCoaches;
var searchUserClients = function (userId, query, page, perPage, additionalParams) {
    if (query === void 0) { query = ""; }
    if (page === void 0) { page = 1; }
    if (perPage === void 0) { perPage = 20; }
    if (additionalParams === void 0) { additionalParams = ""; }
    return axios_1.default.get("".concat(exports.userEndpoint, "/").concat(userId, "/clients?search=").concat(query, "&page=").concat(page, "&perPage=").concat(perPage).concat(additionalParams));
};
exports.searchUserClients = searchUserClients;
var searchCoachTraqs = function (userId, query, page, perPage, additionalParams) {
    if (query === void 0) { query = ""; }
    if (page === void 0) { page = 1; }
    if (perPage === void 0) { perPage = 20; }
    if (additionalParams === void 0) { additionalParams = ""; }
    return axios_1.default.get("".concat(exports.userEndpoint, "/").concat(userId, "/coach-ranks?search=").concat(query, "&page=").concat(page, "&perPage=").concat(perPage).concat(additionalParams));
};
exports.searchCoachTraqs = searchCoachTraqs;
var searchCoachChallenges = function (userId, query, page, perPage, additionalParams) {
    if (query === void 0) { query = ""; }
    if (page === void 0) { page = 1; }
    if (perPage === void 0) { perPage = 20; }
    if (additionalParams === void 0) { additionalParams = ""; }
    return axios_1.default.get("".concat(exports.userEndpoint, "/").concat(userId, "/coach-challenges?search=").concat(query, "&page=").concat(page, "&perPage=").concat(perPage).concat(additionalParams));
};
exports.searchCoachChallenges = searchCoachChallenges;
var searchCoachCourses = function (userId, query, page, perPage, additionalParams) {
    if (query === void 0) { query = ""; }
    if (page === void 0) { page = 1; }
    if (perPage === void 0) { perPage = 20; }
    if (additionalParams === void 0) { additionalParams = ""; }
    return axios_1.default.get("".concat(exports.userEndpoint, "/").concat(userId, "/coach-courses?search=").concat(query, "&page=").concat(page, "&perPage=").concat(perPage).concat(additionalParams));
};
exports.searchCoachCourses = searchCoachCourses;
var searchProviderTraqs = function (userId, query, page, perPage, additionalParams) {
    if (query === void 0) { query = ""; }
    if (page === void 0) { page = 1; }
    if (perPage === void 0) { perPage = 20; }
    if (additionalParams === void 0) { additionalParams = ""; }
    return axios_1.default.get("".concat(exports.userEndpoint, "/").concat(userId, "/provider-ranks?search=").concat(query, "&page=").concat(page, "&perPage=").concat(perPage).concat(additionalParams));
};
exports.searchProviderTraqs = searchProviderTraqs;
var searchProviderChallenges = function (userId, query, page, perPage, additionalParams) {
    if (query === void 0) { query = ""; }
    if (page === void 0) { page = 1; }
    if (perPage === void 0) { perPage = 20; }
    if (additionalParams === void 0) { additionalParams = ""; }
    return axios_1.default.get("".concat(exports.userEndpoint, "/").concat(userId, "/provider-challenges?search=").concat(query, "&page=").concat(page, "&perPage=").concat(perPage).concat(additionalParams));
};
exports.searchProviderChallenges = searchProviderChallenges;
var searchProviderCourses = function (userId, query, page, perPage, additionalParams) {
    if (query === void 0) { query = ""; }
    if (page === void 0) { page = 1; }
    if (perPage === void 0) { perPage = 20; }
    if (additionalParams === void 0) { additionalParams = ""; }
    return axios_1.default.get("".concat(exports.userEndpoint, "/").concat(userId, "/provider-courses?search=").concat(query, "&page=").concat(page, "&perPage=").concat(perPage).concat(additionalParams));
};
exports.searchProviderCourses = searchProviderCourses;
var searchUserCompleteChallenges = function (userId, query, page, perPage, additionalParams) {
    if (query === void 0) { query = ""; }
    if (page === void 0) { page = 1; }
    if (perPage === void 0) { perPage = 20; }
    if (additionalParams === void 0) { additionalParams = ""; }
    return axios_1.default.get("".concat(exports.userEndpoint, "/").concat(userId, "/modules-completed?search=").concat(query, "&page=").concat(page, "&perPage=").concat(perPage).concat(additionalParams));
};
exports.searchUserCompleteChallenges = searchUserCompleteChallenges;
var searchUserCourses = function (userId, query, page, perPage, additionalParams) {
    if (query === void 0) { query = ""; }
    if (page === void 0) { page = 1; }
    if (perPage === void 0) { perPage = 20; }
    if (additionalParams === void 0) { additionalParams = ""; }
    return axios_1.default.get("".concat(exports.userEndpoint, "/").concat(userId, "/courses-participant?search=").concat(query, "&page=").concat(page, "&perPage=").concat(perPage).concat(additionalParams));
};
exports.searchUserCourses = searchUserCourses;
var searchUserChallenges = function (userId, query, page, perPage, additionalParams) {
    if (query === void 0) { query = ""; }
    if (page === void 0) { page = 1; }
    if (perPage === void 0) { perPage = 20; }
    if (additionalParams === void 0) { additionalParams = ""; }
    return axios_1.default.get("".concat(exports.userEndpoint, "/").concat(userId, "/challenges-participant?search=").concat(query, "&page=").concat(page, "&perPage=").concat(perPage).concat(additionalParams));
};
exports.searchUserChallenges = searchUserChallenges;
var searchUserTraqs = function (userId, query, page, perPage, additionalParams) {
    if (query === void 0) { query = ""; }
    if (page === void 0) { page = 1; }
    if (perPage === void 0) { perPage = 20; }
    if (additionalParams === void 0) { additionalParams = ""; }
    return axios_1.default.get("".concat(exports.userEndpoint, "/").concat(userId, "/ranks-participant?search=").concat(query, "&page=").concat(page, "&perPage=").concat(perPage).concat(additionalParams));
};
exports.searchUserTraqs = searchUserTraqs;
var logout = function () {
    return axios_1.default.get("/api/logout");
};
exports.logout = logout;
var getUser = function (userId) {
    return axios_1.default.get("".concat(exports.endpoint, "/").concat(userId));
};
exports.getUser = getUser;
var onboardingFinished = function () {
    return axios_1.default.post("api/p/user/finish-onboarding");
};
exports.onboardingFinished = onboardingFinished;
var getUsersList = function (role) {
    if (role === void 0) { role = undefined; }
    return axios_1.default.get(api_1.endpoints.getUserListByRole, { params: { role: role } });
};
exports.getUsersList = getUsersList;
var searchUsers = function (query, page, perPage, role, self, searchableCols) {
    if (query === void 0) { query = ""; }
    if (page === void 0) { page = 1; }
    if (perPage === void 0) { perPage = 10; }
    if (role === void 0) { role = []; }
    if (self === void 0) { self = 0; }
    if (searchableCols === void 0) { searchableCols = []; }
    return axios_1.default.get(api_1.endpoints.searchUsers, {
        params: {
            search: query,
            page: page,
            perPage: perPage,
            role: role,
            self: self,
            searchableCols: searchableCols,
        },
        paramsSerializer: function (params) {
            return qs_1.default.stringify(params, { arrayFormat: "brackets" });
        },
    });
};
exports.searchUsers = searchUsers;
var getPublicUserProfile = function (userId) {
    return axios_1.default.get("".concat(exports.userEndpoint, "/").concat(userId, "/profile-public"));
};
exports.getPublicUserProfile = getPublicUserProfile;
var getUserProfile = function (userId) {
    return axios_1.default.get(api_1.endpoints.getUserProfile(userId));
};
exports.getUserProfile = getUserProfile;
var createUser = function (email, role, provider) {
    if (provider === void 0) { provider = ""; }
    var form = new FormData();
    form.append("email", email);
    form.append("role", role);
    if (provider)
        form.append("provider", provider);
    return axios_1.default.post(exports.endpoint, form);
};
exports.createUser = createUser;
var updateUser = function (user) { return __awaiter(void 0, void 0, void 0, function () {
    var form, cover, profilePic;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                form = new FormData();
                user.categories.forEach(function (cat) {
                    form.append("user[categories][]", cat.id);
                });
                user.areas_of_interest.forEach(function (aoi) {
                    form.append("user[areas_of_interest][]", aoi.id);
                });
                if (user.isProvider && !user.isProviderAdmin) {
                    form.append("company[business_name]", user.business_name);
                }
                form.append("user[username]", user.username);
                form.append("user[first_name]", user.first_name);
                form.append("user[last_name]", user.last_name);
                form.append("user[bio]", user.bio || "");
                form.append("user[email]", user.email);
                form.append("address[address1]", user.primary_address.addres1);
                form.append("address[city]", user.primary_address.city || "");
                form.append("address[city_id]", user.primary_address.city_id || "");
                form.append("address[state]", user.primary_address.state || "");
                form.append("address[state_id]", user.primary_address.state_id || "");
                form.append("address[state_code]", user.primary_address.state_code || "");
                form.append("address[postal_code]", user.primary_address.postal_code || "");
                form.append("address[country]", user.primary_address.country || "");
                form.append("address[country_id]", user.primary_address.country_id || "");
                form.append("address[country_code]", user.primary_address.country_code || "");
                return [4 /*yield*/, (0, file_1.uploadMedia)(user.cover)];
            case 1:
                cover = _a.sent();
                if (cover)
                    form.append("user[cover]", cover.id);
                if (cover === null)
                    form.append("user[cover]", cover);
                return [4 /*yield*/, (0, file_1.uploadMedia)(user === null || user === void 0 ? void 0 : user.profile_pic)];
            case 2:
                profilePic = _a.sent();
                if (profilePic === null || profilePic === void 0 ? void 0 : profilePic.id)
                    form.append("user[profile_pic]", profilePic.id);
                form.append("_method", "PATCH");
                return [2 /*return*/, axios_1.default.post(exports.profileEndpoint, form)];
        }
    });
}); };
exports.updateUser = updateUser;
var updateUserProfile = function (user) { return __awaiter(void 0, void 0, void 0, function () {
    var first_name, last_name, bio, primary_address, categories, areas_of_interest, business_name, address1, city, city_id, state, state_id, state_code, postal_code, country, country_id, country_code, company, cover, profilePic, userData, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                first_name = user.first_name, last_name = user.last_name, bio = user.bio, primary_address = user.primary_address, categories = user.categories, areas_of_interest = user.areas_of_interest, business_name = user.business_name;
                address1 = primary_address.address1, city = primary_address.city, city_id = primary_address.city_id, state = primary_address.state, state_id = primary_address.state_id, state_code = primary_address.state_code, postal_code = primary_address.postal_code, country = primary_address.country, country_id = primary_address.country_id, country_code = primary_address.country_code;
                company = user.isProvider && !user.isProviderAdmin
                    ? { company: { business_name: business_name } }
                    : {};
                return [4 /*yield*/, (0, file_1.uploadMedia)(user.cover)];
            case 1:
                cover = _a.sent();
                return [4 /*yield*/, (0, file_1.uploadMedia)(user === null || user === void 0 ? void 0 : user.profile_pic)];
            case 2:
                profilePic = _a.sent();
                userData = __assign({ user: __assign(__assign({ first_name: first_name, last_name: last_name, bio: bio, categories: categories.map(function (_a) {
                            var id = _a.id;
                            return id;
                        }), areas_of_interest: areas_of_interest.map(function (_a) {
                            var id = _a.id;
                            return id;
                        }) }, ((cover === null || cover === void 0 ? void 0 : cover.id) ? { cover: cover.id } : {})), ((profilePic === null || profilePic === void 0 ? void 0 : profilePic.id) ? { profile_pic: profilePic.id } : {})), address: {
                        address1: address1,
                        city: city,
                        city_id: city_id,
                        state: state,
                        state_id: state_id,
                        state_code: state_code,
                        postal_code: postal_code,
                        country: country,
                        country_id: country_id,
                        country_code: country_code,
                    } }, company);
                return [2 /*return*/, axios_1.default.patch("/api/user/".concat(user.id, "/update"), __assign({}, userData))];
            case 3:
                error_1 = _a.sent();
                console.error(error_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.updateUserProfile = updateUserProfile;
var searchValidators = function (query, page, perPage) {
    if (query === void 0) { query = ""; }
    if (page === void 0) { page = 1; }
    if (perPage === void 0) { perPage = 4; }
    return axios_1.default.get("".concat(exports.userEndpoint, "/validators"), {
        params: {
            search: query,
            page: page,
            perPage: perPage,
        },
    });
};
exports.searchValidators = searchValidators;
